import { render, staticRenderFns } from "./drupal-boolean.vue?vue&type=template&id=42f5505d&scoped=true&"
import script from "./drupal-boolean.vue?vue&type=script&lang=js&"
export * from "./drupal-boolean.vue?vue&type=script&lang=js&"
import style0 from "./drupal-boolean.vue?vue&type=style&index=0&id=42f5505d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f5505d",
  null
  
)

export default component.exports